/****
 * lodop打印
 */

import lodopUtils from './lodopUtils'
import Vue from 'vue'
import objectUtil from '../../objectUtil'
import calculateUtil from '../../calculateUtil'
import urlUitls from '../../urlUitls'
import templateUtil from '../../templateUtil'

export default class Lodop {
  constructor(axios) {
    this.OPrinter = lodopUtils()
    this.axios = axios
    this.urlParam = null
    this.PrinterData = { defaultPrinterName: null }
  }
  //显示打印的总页数
  allPage() {
    if (this.urlParam?.length > 0 && this.urlParam[0]?.parameter?.allPage) {
      this.OPrinter.allPage()
    }
  }
  //预览
  preview() {
    this.allPage()
    this.OPrinter.preview()
  }
  //增加页
  addPage(content, num, newPage = true) {
    const len = num && num !== 'undefined' ? num : 1
    // 需求6543 ：模板内容（content）存在才进行下一步
    if (content) {
      for (let i = 0; i < len; i++) {
        this.OPrinter.addContent(content, !newPage && i === 0 ? false : true)
      }
    }
  }
  //打印
  print(num = 1) {
    this.allPage()
    this.OPrinter.print(num)
  }
  _printBeforePrint() {
    this.OPrinter._printBeforePrint()
  }
  //获取打印机
  async getPrinter() {
    return new Promise((resolve) => {
      this.OPrinter.init({}, () => {
        resolve(this.OPrinter.getPrinters())
      })
    })
  }
  //设置打印机
  setPrinterIndex(index) {
    if (index && index !== 0) {
      this.OPrinter.setPrinterIndex(index)
    }
  }
  //设置打印尺寸
  setSize(data) {
    // "papper": "A4|A3|FREE",
    // "orientation": "horizontal|vertical",
    // "width": 1,
    // "height": 1,
    // "top": 1,
    // "bottom": 1,
    // "left": 1,
    // "right": 1
    let temp = {
      print_orient: data.orientation == 'horizontal' ? 2 : 1, //打印方向及纸张类型，数字型.1---纵(正)向打印，固定纸张；
      paper_top: 0, //整页上边距，整数或字符型
      paper_left: 0, //整页左边距
      paper_width: data.width + 'mm', //可视编辑区域的宽度.A4 21*29.7cm（210mm×297mm）
      paper_height: data.height + 'mm', //可视编辑区域的高度
      html_top: data.top + 'mm', //html上边距，整数或字符型
      html_left: data.left + 'mm', //html上边距，整数或字符型
      html_width: data.orientation == 'horizontal' ? data.right + 'mm' : data.right + 10.2 + 'mm', //html右边距（10.2是误差）
      html_height: data.orientation == 'horizontal' ? data.bottom + 'mm' : data.bottom + 'mm', //html下边距
    }
    this.OPrinter.setPrint_paramByUICustomHtml(temp)
  }
  //如果配置了splitBill，表示拆单打印返回拆单后的数据，否则返回传入的数据的数组
  async setSplitBillData(item, dataset) {
    if (dataset?.splitBill) {
      let urlParam = dataset?.splitBill
      let url = null
      let method = 'get'
      let params = {}
      if (typeof urlParam === 'object') {
        url = urlParam.url ?? url
        method = urlParam.method ?? 'get'
        params = templateUtil.compileData(urlParam.params ?? params, item) //编译传入参数，参数支持{{}}
      } else {
        url = urlParam
      }
      url = templateUtil.compileData(url, item)
      let temp = await this.getData(url, method, params)
      const resArr = Array.isArray(temp) ? temp : [temp]
      return resArr.map((im) => ({ ...item, splitBillData: im }))
    } else {
      return [item]
    }
  }
  // str -> 打印的模板
  // dataset -> 编译模板的数据源请求接口
  //{
  // order: 'rest/order/get?id={{order}}'
  // orderItem: 'rest/order/getItem?id={{order}}'
  //}
  //这里是先将模板编译的数据通过接口获取到放入编译的源对象中，然后再进行模板编译；对应接口的key就是该接口返回的数据在编译对象中的key
  //item存在就表示是批量打印
  async compileContent(str, dataset, item = null, style) {
    let promiseArr = []
    let keyArr = []

    for (let key in dataset) {
      if (key !== 'splitBill') {
        let urlParam = dataset[key]
        let url = null
        let method = 'get'
        let params = {}
        if (typeof urlParam === 'object') {
          url = urlParam.url ?? url
          method = urlParam.method ?? 'get'
          // params = urlParam.params ?? params
          params = templateUtil.compileData(urlParam.params ?? params, item) //编译传入参数，参数支持{{}}
        } else {
          url = urlParam
        }
        url = templateUtil.compileData(url, item)
        let temp = this.getData(url, method, params)
        keyArr.push(key)
        promiseArr.push(temp)
      }
    }

    let tempCom = Object.assign({}, item)
    const res = await Promise.all(promiseArr)
    for (let i = 0; i < res.length; i++) {
      // 需求6543 ：获取打印的明细数据(用于判断该数据是否是需要进项打印的数据)
      //Object.hasOwn(res[i], 'items') ||  在低版本的浏览器上会报错
      if (Array.isArray(res[i]?.items) && res[i]?.items.length == 0) {
        let itemData = res[i].items
        if (!itemData?.length) return
      }
      tempCom[keyArr[i]] = res[i]
    }
    return this.compileTemplate(str, tempCom, style)
  }
  async getDeploy(param) {
    const res = await this.axios
      .get('rest/ezcomp/report/templateDetail', { params: param })
      .catch((error) => {
        console.error(error)
      })
    if (res.data.code == 200) {
      return res.data.data
    } else {
      console.error(res.data.msg)
    }
  }
  getData(url, method = 'get', params = {}) {
    return new Promise((resolve, reject) => {
      if (method === 'get' && params) {
        params = {
          params,
        }
      }
      this.axios[method](url, params)
        .then((res) => {
          if (res.data.code == 200) {
            resolve(res.data.data)
          } else {
            console.error(res.data.msg)
            reject(res.data.msg)
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  }
  async compileTemplate(template, data, style) {
    const escapeHtml = (string) => {
      var entityMap = {
        '&amp;': '&',
      }
      return String(string).replace(/&amp;/g, function (s) {
        return entityMap[s]
      })
    }
    let complieComponent = Vue.extend({
      data() {
        return data
      },
      methods: {
        getDomain(url) {
          return urlUitls.getDomain(url)
        },
        // calcDigits:用于计算的小数位数，默认6位小数
        // 【上海市中西医结合医院（本地）】反应保留2位小数的时候，合计值与明细的合计不一样（保留4位小数值位0.8900，但是保留2位变成了0.90）
        totalFn(arr, key, digits = 2, symbol, chinese, calcDigits = 6) {
          let tempArr = arr || []
          let total = 0
          for (let item of tempArr) {
            total = calculateUtil.numberAdd(total, objectUtil.getValueByPath(item, key), calcDigits)
          }
          //表示需要将小写转为大写
          let date = new Date().format(total, 'number', digits)
          if (chinese) {
            // 数字为0时，重置date为空（如果不这样操作的话，数字为0时转大写，会原模原样返回，即：0或0.00 => 返回 0或0.00，就不能实现转大写的需求）
            var dataFixed = parseFloat(date.replace(/,/g, ''))
            if (!dataFixed) date = ''

            date = calculateUtil.convertCurrency(date)
          }
          return `${symbol}${date}`
        },
        digitFn(date, digits = 2) {
          return new Date().format(date, 'number', digits)
        },
        getNowDate(formatter = 'YYYY-MM-DD HH:mm:ss', dateString = '') {
          let dateModel = new Date()
          if (dateString) dateModel = new Date(dateString)
          return dateModel.format(dateModel, 'date', formatter)
        },
        translateCode(data) {
          return window.encodeURI(data.replace(/\(/g, '[').replace(/\)/g, ']'))
        },
      },
      template: `<div>${template}</div>`,
    })
    //   如果没有style 就返回有style的字符串
    var complieComponentDom = new complieComponent().$mount()

    // 等待Vue完成DOM更新，确保v-if和:src等指令完全渲染
    await complieComponentDom.$nextTick()

    // 再等待一个微任务，确保所有异步更新完成
    await new Promise((resolve) => setTimeout(resolve, 0))

    // 获取渲染后的HTML
    const html = complieComponentDom.$el.innerHTML

    // 主动销毁Vue实例，避免内存泄漏
    complieComponentDom.$destroy()

    if (style) return escapeHtml(style + html)
    else return escapeHtml(html)
  }

  //组装参数
  setParam(url, templateData, data, skipParamter) {
    if (data && !Array.isArray(data)) {
      //不是批量的情况
      data = [data]
    }
    let paramAarr = []
    for (let item of data) {
      let tempUrl = url
      templateData.data = item
      tempUrl = templateUtil.compileData(tempUrl, templateData)
      let paramItem = urlUitls.getRequestParamter(tempUrl)
      paramItem = Object.assign(paramItem, skipParamter)
      //将打印的单据数据放入参数
      paramItem.orderData = item
      paramItem = {
        viewlet: paramItem.viewlet,
        parameter: paramItem,
      }
      delete paramItem.parameter.viewlet
      paramAarr.push(paramItem)
    }
    return paramAarr
  }

  async startPrint(urlParam, printer = {}, browser, message) {
    const { print = false, printerIndex = null } = printer
    if (!urlParam?.length) return
    this.urlParam = urlParam

    //获取打印模板详情
    const templateData = await this.getDeploy({ viewlet: this.urlParam[0].viewlet })
    if (!templateData) return
    if (!browser) {
      this.setSize(templateData.print)
      this._printBeforePrint()
    }
    // 批量取数
    const model = templateData.batch && templateData.batch != 0 ? Number(templateData.batch) : 0
    let modelTemp = model
    let tempDataArr = [] // 需求6543 ：存储编译后有内容的模板数据
    if (model && model > 0) {
      let tempData = ''
      for (let i = 0; i < this.urlParam.length; i++) {
        let item = this.urlParam[i]
        const splitBillArr = await this.setSplitBillData(item.parameter, templateData.dataset)
        for (let j = 0; j < splitBillArr.length; j++) {
          const splitItem = splitBillArr[j]
          const _print_ = splitItem._print_ ? Number(splitItem._print_) : 1 // 至少打印一张
          for (let k = 1; k <= _print_; k++) {
            // 如果要批量取数 style 就不应分布在每个模板中，再浏览器打印时，直接放在最外侧层的模板中
            let compileContentData = await this.compileContent(
              templateData.content,
              templateData.dataset,
              splitItem,
              ''
            )
            tempData += `${
              modelTemp == model
                ? '<div style="page-break-after: always; width:' +
                  templateData.print.width +
                  'mm; height:' +
                  templateData.print.height +
                  'mm">'
                : ''
            }${compileContentData}${modelTemp - 1 == 0 ? '</div>' : ''}`
            modelTemp -= 1
            if (modelTemp == 0) modelTemp = model
          }
        }
      }

      this.browser(tempData, templateData.style)
    } else {
      for (let i = 0; i < this.urlParam.length; i++) {
        let item = this.urlParam[i]
        const splitBillArr = await this.setSplitBillData(item.parameter, templateData.dataset)
        for (let j = 0; j < splitBillArr.length; j++) {
          const splitItem = splitBillArr[j]
          const tempData = await this.compileContent(
            templateData.content,
            templateData.dataset,
            splitItem,
            templateData.style || ''
          )
          // 需求6543 ：存储编译后有内容的模板数据
          if (tempData) {
            tempDataArr.push(tempData)
          }
          if (browser) {
            this.browser(tempData)
          } else {
            this.addPage(tempData, splitItem?._print_, i === 0 && j === 0 ? false : true)
          }
        }
      }
    }

    if (browser) return
    this.setPrinterIndex(printerIndex)
    // 需求6543
    if (tempDataArr && tempDataArr.length > 0) {
      !print ? this.preview() : this.print()
    } else {
      message.error(`因数量为零的数据已过滤,目前无打印数据~`)
    }
  }

  //执行打印;  browser为true时表示调用浏览器打印
  // 需求6543 ：增加 无打印数据时的提示 参数message
  run(urlParam, printer = {}, browser, message) {
    if (!urlParam?.length) return
    this.urlParam = urlParam
    if (browser) {
      this.startPrint(urlParam, printer, browser)
    } else {
      this.OPrinter.init(this.PrinterData, () =>
        this.startPrint(urlParam, printer, browser, message)
      )
    }
  }
  //调用浏览器打印
  browser(str, style) {
    //打开一个新窗口newWindow
    //要打印的div的内容
    var docStr = `<!DOCTYPE html>
        <html lang="zh-CN" style="margin:0;padding:0">
        <head>
            <meta>
            ${style ? style : ''}
        </head>
        <body style="margin:0;padding:0"><div id="pgPrintWindow">${str}</div></body>
        </html>`
    //打印内容写入newWindow文档
    const newIframe = window.document.createElement('iframe')
    newIframe.setAttribute('name', 'browser-print')
    newIframe.style.display = 'none'
    window.document.body.appendChild(newIframe)

    var newWindow = window.open('打印窗口', 'browser-print')
    newWindow.document.write(docStr)
    // {/* <img */}
    if (/<img /.test(docStr)) {
      const imgs = newWindow.document.getElementsByTagName('img')
      const successArr = []
      for (let item of imgs) {
        item.onload = function () {
          successArr.push('success')
          if (successArr.length === imgs.length) {
            newWindow.document.close()
            //调用打印机
            newWindow.print()
            // 关闭newWindow页面
            newWindow.close()
            newWindow.document.body.remove()
            window.document.body.removeChild(newIframe)
          }
        }
      }
    } else {
      //关闭文档
      newWindow.document.close()
      //调用打印机
      newWindow.print()
      // 关闭newWindow页面
      newWindow.close()
      newWindow.document.body.remove()
      window.document.body.removeChild(newIframe)
    }
  }
}
